import ActiveOptionViewState, { ActiveItem } from '../../store/schema/ActiveOptionViewState';
import initializeAutomaticRepliesViewState from '../../actions/automaticReplies/initializeAutomaticRepliesViewState';
import { getOptionsStore } from '../../store/Store';
import { mutator } from 'satcheljs';

const initializeAutomaticRepliesViewStateMutator = mutator(
    initializeAutomaticRepliesViewState,
    actionMessage => {
        const store = getOptionsStore();
        if (store) {
            store.activeViewState = {
                name: ActiveItem.AutomaticReplies,
                isLoading: true,
                isDirty: false,
                isAutomaticRepliesEnabled: false,
                replyToExternalSendersText: null,
                replyOnlyToMyOrganizationText: null,
                isReplyToEveryone: true,
                isReplyOnlyToMyOrganization: false,
                isDifferentReplyForOrgAndExternalSenders: false,
            } as ActiveOptionViewState;
        }
    }
);

export default initializeAutomaticRepliesViewStateMutator;
